<template>
  <div class="supplier-info">
    <div v-if="ratingExpire" class="supplier-info__rating__expire">
      {{ $t('record.disable_rating_note') }}
    </div>
    <div v-if="order.rating_by_user" class="supplier-info__rated">
      <div class="supplier-info__rated__detail d-flex">
        <div class="supplier-info__rated-desc">
          {{ $t('record.user_rated_as', { label: rateLabel }) }}
        </div>
        <Rating
          class="supplier-info__rated-component"
          read-only
          disabledRating
          :size="isMobile ? '16' : '24'"
          :rateValue="order.rating_by_user"
        />
      </div>
    </div>
    <div class="supplier-info__chat-btn d-flex" v-if="contactSupplierVisible || chatHistoryVisible">
      <div
        v-if="contactSupplierVisible"
        class="supplier-info__license-plate"
        data-test-id="license_plate"
      >
        {{ licensePlate }}
      </div>
      <a
        v-if="contactSupplierVisible"
        :href="'tel:' + this.phoneNumber"
        class="supplier-info__phone-number"
      >
        <div data-test-id="phone_number">
          <SvgIcon class="info-icon" height="20" width="20" icon="CallOutlineBlue" />
          {{ formattedPhone }}
        </div>
      </a>
      <!-- <div v-if="!contactSupplierVisible" class="supplier-info__chat-expire">
        {{ $t('record.chat_history_note', { days: 3 }) }}
      </div> -->
      <Chat
        activatorIcon
        activatorFlat
        hiddenPhoneNumber
        :order="order"
        :historyMode="chatHistoryVisible"
        :hide-message="hideMessageChat"
        class="supplier-info__chat-component"
      />
    </div>
  </div>
</template>

<script>
import { formatPhoneNumber } from '@/plugins/util'
// import Chat from "@/components/record_detail/Chat.vue";
const Chat = () => import(/* webpackMode: "lazy" */ '@/components/record_detail/Chat')

import Rating from '@/components/records/Rating'

const CHAT_VISIBLE_DURATION = 3 * 24 * 60 * 60 // 3 days - seconds

export default {
  name: 'SupplierInfo',
  components: {
    Chat,
    Rating
  },
  props: {
    order: {
      type: Object
    },
    licensePlate: {
      type: String,
      defailt: ''
    },
    phoneNumber: {
      type: String,
      defailt: ''
    },
    hideMessageChat: {
      type: Boolean,
      default: false
    },
    showRatingNoteExpire: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedPhone() {
      return (this.phoneNumber && formatPhoneNumber(undefined, this.phoneNumber)) || ''
    },
    ratingExpire() {
      return (
        !this.order.rating_by_user &&
        this.showRatingNoteExpire &&
        this.order.status === this.$constants.ORDER_STATUS.COMPLETED
      )
    },
    chatHistoryVisible() {
      if (this.order.status === this.$constants.ORDER_STATUS.COMPLETED) {
        const compeleteTime = this.$moment.unix(this.order.complete_time)
        const diff = this.$moment().diff(compeleteTime, 'seconds')

        if (diff < CHAT_VISIBLE_DURATION) return true
      }

      return false
    },
    contactSupplierVisible() {
      return (
        this.order.status === this.$constants.ORDER_STATUS.ACCEPTED ||
        this.order.status === this.$constants.ORDER_STATUS.IN_PROCESS ||
        this.order.sub_status === this.$constants.ORDER_STATUS.IN_RETURN
      )
    },
    rateLabel() {
      return this.order.rating_by_user > 0
        ? this.$t('rating.value_label.' + this.order.rating_by_user)
        : ''
    },
    rateIcon() {
      return this.order.rating_by_user > 0 ? `Rating${this.order.rating_by_user}` : ''
    }
  },
  methods: {}
}
</script>

<i18n src="@/locales2/share/ratingValue.json"></i18n>

<style lang="scss" scoped>
$height: 60px;

.supplier-info {
  width: 100%;
  align-items: center;
  border-top: 1px solid #f2f2f2;

  > div {
    border-bottom: 1px solid #f2f2f2;
  }

  .supplier-info__license-plate {
    width: 40%;
    line-height: $height;
    text-align: center;
    color: #1a1a1a;
  }

  .supplier-info__phone-number {
    flex: 1;
    text-align: center;
    color: #007cff;
    font-weight: 500;

    &:link {
      text-decoration: none;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: $height;
      height: calc(#{$height} - 22px);
      border-left: 1px solid #f2f2f2;

      .info-icon {
        margin-right: 4px;
      }
    }
  }

  .supplier-info__chat-btn {
    // width: 52px;
    height: $height;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    > div:first-child {
      width: 80%;
      color: #1a1a1a;
      font-weight: 600;
      line-height: 24px;
    }

    .supplier-info__license-plate {
      width: 40% !important;
    }
  }

  .supplier-info__rating__expire {
    min-height: $height;
    padding-left: 18px;
    color: #1a1a1a;
    font-weight: 600;
    line-height: 52px;
    // border-bottom: 1px solid #f2f2f2;
  }

  .supplier-info__rated {
    display: flex;
    align-items: center;
    justify-content: space-around;
    min-height: $height;
    width: 100%;
    // border-bottom: 1px solid #f2f2f2;

    .rated-icon {
      min-width: 32px;
      margin: 0 4px;
    }

    .supplier-info__rated__detail {
      width: 100%;
      margin: 0 16px;

      > div:first-child {
        color: #1a1a1a;
        font-weight: 600;
        line-height: 30px;
        width: 50%;
      }

      .supplier-info__rated-component {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .supplier-info {
    .supplier-info__chat-btn {
      font-size: 12px;

      > div:first-child {
        margin-left: 0;
      }

      .supplier-info__chat-expire {
        padding-left: 16px;
      }

      .supplier-info__license-plate {
        width: 30% !important;
      }
    }

    .supplier-info__rated {
      .supplier-info__rated__detail {
        .supplier-info__rated-desc {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
